
import { Vue, Options, prop } from "vue-class-component";
import ReferralModal from "@/app/ui/components/modal-v2/index.vue";
import copy from "copy-text-to-clipboard";
import {
  convertHtmlToPlain,
  formatPrice
} from "@/app/infrastructures/misc/Utils";
import term from "./term";

class Props {
  referralCode = prop<string>({
    type: String,
    default: ""
  });
}

@Options({
  components: {
    ReferralModal
  }
})
export default class Dashboard extends Vue.with(Props) {
  referralDialogModelValue = false;
  toggleReferalDialog(bool: boolean) {
    this.referralDialogModelValue = bool;
  }

  onCloseModal() {
    this.referralDialogModelValue = false;
  }

  get term() {
    return term({
      period: "April - September 2022",
      topUp: formatPrice(3000000),
      incentive: formatPrice(500000),
      code: this.referralCode,
      paidPeriod: "M+1",
      phone: "0812-1027-7690"
    });
  }

  copyNotification = false;
  autoCopy() {
    const contentCopy =
      "Hai, Punya mimpi untuk punya usaha pengiriman sendiri? dan bisa dapat komisi ratusan juta tiap bulan?\n\n" +
      "Ayo bergabung menjadi Agen Mitra POS Lion Parcel, modal kecil CUAN BESAR!\n\n" +
      "Kenapa harus Lion Parcel?\n" +
      "- Proses mudah dan cepat! Hanya 10 hari!\n" +
      "- Komisi besar untuk setiap agen\n" +
      "- Harga ongkir kompetitif\n" +
      "- Lion Parcel sudah tersebar di seluruh Indonesia\n\n" +
      `Daftar Sekarang menjadi Agen Mitra POS Lion Parcel. Klik disini untuk mendaftar https://lionparcel.com/agen/perorangan-app?referral=${this.referralCode} dan masukkan kode referral ${this.referralCode}`;
    copy(convertHtmlToPlain(contentCopy));
    this.copyNotification = true;
  }

  removeCopyNotification() {
    this.copyNotification = false;
  }
}
